import { Document, Page, StyleSheet, Image, Text } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontSize: "30px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
});

const ComicPDF = ({ images, name }) => {
  return (
    <Document>
      <Page key={1} size="A4" style={styles.page}>
        <Text style={styles.title}>{name}</Text>
      </Page>
      {images?.map((link, index) => (
        <Page key={index} size="A4" style={styles.page}>
          <Image
            style={styles.image}
            src={link}
            //src={`http://127.0.0.1:8000${link}`}
          />
        </Page>
      ))}
    </Document>
  );
};

export default ComicPDF;
